import { get, post,put } from "../Config";

// GET
export function SearchDoctorList({ params }) {
  return get({ url: `/api/sb/v1/doctor`,params});
}
